export const validateNumber = value => {
  let isValid = false
  const reg = /^-?[0-9]*(\.[0-9]*)?$/

  if ((!Number.isNaN(value) && reg.test(value)) || value === '') {
    isValid = true
  }
  return isValid
}
